import { ServiceModel } from "../../../entities";
import { BaseODataRepository } from "../../BaseODataRepository";

export class ServiceODataRepo extends BaseODataRepository<ServiceModel> {
  protected baseUrl = `/OData/services`;
}
